function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.203 12.06a1.5 1.5 0 010 2.122l-7.778 7.778c-.257.256-.583.4-.917.433l-.144.006c-.384 0-.768-.146-1.06-.439l-4.243-4.242a1.5 1.5 0 112.121-2.122l3.182 3.182 6.717-6.717a1.5 1.5 0 012.122 0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgBig = function SvgBig(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 34,
      height: 34
    }, props), _ref)
  );
};

export default SvgBig;